import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Venues() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("venues.title", "Venue Accounts")}
      subtitle={t("venues.subtitle", "Showcase your space, manage bookings, and grow your audience")}
    >
      <div className="space-y-8">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("venues.accountTitle", "🏢 What is a Venue Account?")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "venues.accountText",
              "A Venue Account allows clubs, bars, concert halls, studios, and event spaces to manage their events, promote upcoming shows, and connect with attendees on PartyBuddy."
            )}
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("venues.toolsTitle", "Venue Management Tools")}
          </h2>
          <ul className="space-y-3 text-slate-300">
            {[
              ["listings", "Event Listings:", "Create and manage all events happening at your venue"],
              ["profile", "Venue Profile:", "Showcase your space with photos, capacity info, and amenities"],
              ["connections", "Promoter Connections:", "Connect with promoters and artists booking your space"],
              ["insights", "Audience Insights:", "Understand your attendees and plan future events"],
              ["ticketing", "Ticketing Integration:", "Sell tickets directly or through partner platforms"],
            ].map(([key, fallbackLabel, fallbackText]) => (
              <li key={key} className="flex gap-3">
                <span className="text-blue-400">→</span>
                <span>
                  <strong>{t(`venues.tools.${key}.label`, fallbackLabel)}</strong>{" "}
                  {t(`venues.tools.${key}.text`, fallbackText)}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("venues.typesTitle", "Types of Venues")}
          </h2>
          <ul className="space-y-2 text-slate-300">
            {[
              ["concert", "🎵 Concert venues and music clubs"],
              ["bars", "🍺 Bars, pubs, and lounges"],
              ["theaters", "🎭 Theaters and performing arts spaces"],
              ["nightclubs", "🎪 Nightclubs and dance venues"],
              ["galleries", "🎨 Art galleries and creative spaces"],
              ["comedy", "🎤 Comedy clubs and stand-up venues"],
              ["sports", "🏟️ Sports bars and event spaces"],
            ].map(([key, fallback]) => (
              <li key={key}>{t(`venues.types.${key}`, fallback)}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("venues.listTitle", "List Your Venue")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "venues.listText1",
              "Venue partnerships are currently in development. Interested venues can early-access the platform and help shape the future of venue promotion on PartyBuddy."
            )}
          </p>
          <p className="text-slate-300">
            {t("venues.listText2Prefix", "Contact us at")}{" "}
            <a
              href="mailto:venues@partybuddy.app"
              className="text-blue-400 transition hover:text-blue-300"
            >
              venues@partybuddy.app
            </a>{" "}
            {t("venues.listText2Suffix", "to learn more.")}
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Venues;
